<template>
  <div class="content-cookie-declaration" ref="contentTextElement">
    <div class="grid">
      <h2 class="title" ref="titleElement">Cookies</h2>
      <div class="textfields" ref="textfieldsElement">
        <div class="textfield">
          <component
            is="script"
            id="CookieDeclaration"
            src="https://consent.cookiebot.com/5cb74643-59ea-4622-8e96-7c10fc18bab2/cd.js"
            type="text/javascript"
            async
          ></component>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import useTextFadeIn from '~/utils/useTextFadeIn';

const contentTextElement = ref<null | HTMLElement>(null);
const textfieldsElement = ref<null | HTMLElement>(null);
const titleElement = ref<null | HTMLElement>(null);

useTextFadeIn(contentTextElement, [titleElement, textfieldsElement]);
</script>

<style scoped lang="scss">
.content-cookie-declaration {
  background-color: var(--background, var(--color-off-white));

  @media (--vs) {
    padding: 3rem var(--base-component-padding-inline-with-margins);
  }
  @media (--vl) {
    padding: 4rem var(--base-component-padding-inline-with-margins) 6rem
      var(--base-component-padding-inline-with-margins);
  }

  > .grid {
    @extend %base-grid;

    @media (--vl) {
      > .title {
        grid-area: 1 / 1 / 2 / 2;
      }

      > .textfields {
        grid-area: 1 / 2 / 2 / 3;
      }
    }

    > .title {
      @include text-2xl(700);

      hyphens: auto;
    }

    > .textfields {
      display: flex;
      flex-direction: column;

      @media (--vs) {
        gap: 1.5rem;
      }
      @media (--vl) {
        gap: 2.5rem;
      }

      > .textfield {
        > .title {
          @include text-md(700);

          padding-bottom: 0.5rem;
        }

        > .text {
          @include text-md(300);
        }
      }
    }
  }
}
</style>
